import { render, staticRenderFns } from "./member_grouping.vue?vue&type=template&id=2a6bd56a&scoped=true"
import script from "./member_grouping.vue?vue&type=script&lang=js"
export * from "./member_grouping.vue?vue&type=script&lang=js"
import style0 from "./member_grouping.vue?vue&type=style&index=0&id=2a6bd56a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6bd56a",
  null
  
)

export default component.exports